import React from 'react';
import { PageTitle } from '../components/titles';

export const FourOhFour: React.FC = () => (
  <PageTitle title="Page not Found" />
);
